import React from "react"
import { useStats } from "react-instantsearch"
import { useTranslation } from "gatsby-plugin-react-i18next"

const SearchResultStats = () => {
  const { nbHits, query } = useStats()
  const { t } = useTranslation()

  return (
    <div className="m-auto px-3 mt-3 mb-1 font-semibold text-dark-sage italic break-all">
      {nbHits === 0 ? (
        <>{t("noSearchResults", { query: query })}</>
      ) : (
        <>
          {t("searchResultsStats", {
            nbHits: nbHits,
            query: query,
          })}
        </>
      )}
    </div>
  )
}

export default SearchResultStats
